/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleDtoPage } from '../../models/role-dto-page';

export interface ListAddableRoles$Params {
  memberId: string;
  projectId?: string | null;
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'isDefault' | '-isDefault' | 'grants' | '-grants' | 'customFieldsGrants' | '-customFieldsGrants' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'grantsCount' | '-grantsCount' | 'customFieldsGrantsCount' | '-customFieldsGrantsCount'>;
}

export function listAddableRoles(http: HttpClient, rootUrl: string, params: ListAddableRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listAddableRoles.PATH, 'get');
  if (params) {
    rb.query('memberId', params.memberId, {});
    rb.query('projectId', params.projectId, {});
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleDtoPage>;
    })
  );
}

listAddableRoles.PATH = '/v0/roles/addable';
